function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { validEmail } from '@domain-group/fe-helper';
import { AlertIcon } from '@domain-group/fe-co-icon';
import Loader from '@domain-group/fe-co-loader';
import { SignInType } from '@domain-group/fe-allhomes-library';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import UserInput from './user-input';
import Footer from './footer';
import * as styles from './sign-in.style';
import * as commonStyles from '../../style/common.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class SignInPage extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getFieldValue", key => this.state.signInFields[key].value);
    _defineProperty(this, "getData", () => ({
      username: this.getFieldValue('username').trim(),
      password: this.getFieldValue('password').trim()
    }));
    _defineProperty(this, "submitForm", () => {
      if (!this.validate()) {
        return;
      }
      this.setState({
        isSubmitting: true
      });
      var _this$getData = this.getData(),
        username = _this$getData.username,
        password = _this$getData.password;
      this.props.onSignInClick(username, password).finally(() => {
        this.setState({
          isSubmitting: false
        });
      });
    });
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.signInFields[key];
      var error;
      if (field.required && !value) {
        error = field.requiredErrorMessage;
      } else if (field.validate) {
        error = field.validate(value);
      }
      return {
        value,
        error: error || ''
      };
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.signInFields[key].value.trim())
      }), {});
      this.setState({
        signInFields: newState
      });
      return Object.values(newState).every(_ref => {
        var error = _ref.error;
        return !error;
      });
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = {
        value,
        error: ''
      };
      this.setState(prevState => ({
        signInFields: _objectSpread(_objectSpread({}, prevState.signInFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "resendActivationClick", email => {
      this.props.onResendActivationClick({
        email
      });
      this.setState({
        resendActivation: true
      });
    });
    _defineProperty(this, "renderField", (key, type) => {
      var field = this.signInFields[key];
      var fieldState = this.state.signInFields[key];
      return ___EmotionJSX(UserInput, _extends({
        iconName: field.icon,
        fieldType: type,
        fieldName: key,
        placeHolder: field.label,
        onValueChange: event => this.handleFieldChange(key, event.target.value)
      }, field.canSubmit ? {
        onSubmit: this.submitForm
      } : {}, {
        fieldError: fieldState.error,
        fieldValue: fieldState.value,
        focus: field.focus || false
      }));
    });
    this.signInFields = {
      username: {
        label: 'Email',
        icon: 'email',
        required: true,
        requiredErrorMessage: 'Please enter an email address',
        validate: value => validEmail(value) ? '' : 'Invalid email address',
        focus: !this.props.initialUsername
      },
      password: {
        label: 'Password',
        icon: 'lock',
        required: true,
        requiredErrorMessage: 'Please enter your password',
        canSubmit: true,
        focus: Boolean(this.props.initialUsername)
      }
    };
    this.allFields = Object.keys(this.signInFields);
    this.state = {
      isSubmitting: false,
      signInFields: {
        username: {
          value: this.props.initialUsername,
          error: ''
        },
        password: {
          value: '',
          error: ''
        }
      },
      resendActivation: false
    };
  }
  componentDidMount() {
    setTimeout(() => {
      document.getElementsByName('username')[0].focus();
    }, 1);
  }
  render() {
    var _this$props = this.props,
      error = _this$props.error,
      _this$props$signInTyp = _this$props.signInType,
      signInType = _this$props$signInTyp === void 0 ? SignInType.SIGN_IN : _this$props$signInTyp,
      onSignUpClick = _this$props.onSignUpClick,
      onForgotPasswordClick = _this$props.onForgotPasswordClick,
      isEuUser = _this$props.isEuUser;
    var title = signInType.title,
      subtitle = signInType.subtitle;
    var Messages = {
      NEEDS_ACTIVATION: "You've created a My Allhomes account but haven't activated it yet.",
      LOGIN_FAILED: 'Sorry, either the email or password is incorrect.',
      ERROR: 'Failed to submit request. Please try again later.',
      LOCKED: 'Your account may be locked. Please reset your password using the link below'
    };
    return this.state.resendActivation && error.length === 0 ? ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.confirmationTitle
    }, "Sent!"), ___EmotionJSX("div", {
      css: commonStyles.confirmationHeaderContent
    }, "Check your inbox (or spam folder) at", ___EmotionJSX("span", {
      css: styles.bodyTextBold
    }, "\xA0", this.getFieldValue('username')), ___EmotionJSX("br", null), " ", ___EmotionJSX("br", null)), ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, ___EmotionJSX(Button, {
      css: styles.gotItButton,
      onClick: this.props.onCloseModalCallback
    }, "OK"))) : ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: commonStyles.title
    }, title), ___EmotionJSX("div", {
      css: commonStyles.subTitle
    }, subtitle), error.length > 0 && ___EmotionJSX("div", {
      css: commonStyles.formSubmitError
    }, ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorIcon
    }, ___EmotionJSX(AlertIcon, {
      size: "regular"
    })), ___EmotionJSX("div", {
      css: commonStyles.formSubmitErrorMessage
    }, Messages[error[0].message], error[0].message === 'NEEDS_ACTIVATION' && ___EmotionJSX(Button, {
      css: styles.resendActivationButton,
      appearance: "ghost",
      onClick: () => this.resendActivationClick(this.getFieldValue('username'))
    }, "Send the activation link again?"))), ___EmotionJSX("div", {
      role: "form",
      "aria-label": "Sign in to Allhomes",
      id: "sign-in"
    }, this.renderField('username', 'text'), this.renderField('password', 'password'), ___EmotionJSX(Button, {
      css: commonStyles.submitButton,
      onClick: this.submitForm,
      disabled: this.state.isSubmitting
    }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
      css: commonStyles.submitButtonLoader,
      dark: true,
      transparent: true,
      size: "mini"
    }) : 'Log in'), ___EmotionJSX(Button, {
      css: commonStyles.buttonContainerItem,
      appearance: "ghost",
      onClick: () => onForgotPasswordClick(this.getFieldValue('username'))
    }, "Forgot your password?"), !isEuUser && (signInType === null || signInType === void 0 ? void 0 : signInType.type) !== SignInType.ACTIVATION.type && ___EmotionJSX("div", {
      css: commonStyles.buttonDivider
    }), !isEuUser && (signInType === null || signInType === void 0 ? void 0 : signInType.type) !== SignInType.ACTIVATION.type && ___EmotionJSX("div", {
      css: commonStyles.buttonContainer
    }, "Don't have an account?", ' ', ___EmotionJSX(Button, {
      css: styles.signUpButton,
      appearance: "ghost",
      onClick: () => onSignUpClick(this.getFieldValue('username'))
    }, ___EmotionJSX("span", {
      css: commonStyles.linkButtonText
    }, "Sign up")))), ___EmotionJSX(Footer, {
      onCloseModal: this.props.onCloseModalCallback
    }));
  }
}
SignInPage.propTypes = {
  initialUsername: PropTypes.string,
  error: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string
  })),
  onSignInClick: PropTypes.func,
  onSignUpClick: PropTypes.func,
  onForgotPasswordClick: PropTypes.func,
  isEuUser: PropTypes.bool,
  signInType: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    type: PropTypes.string
  }),
  onResendActivationClick: PropTypes.func,
  onCloseModalCallback: PropTypes.func
};
SignInPage.defaultProps = {
  initialUsername: '',
  error: [],
  isEuUser: false,
  onSignInClick: () => {},
  onSignUpClick: () => {},
  onForgotPasswordClick: () => {},
  signInType: undefined,
  onResendActivationClick: () => {},
  onCloseModalCallback: () => {}
};
export default SignInPage;